import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableMetaComponent} from './table-meta/table-meta.component';
import {RowDetailComponent} from './table-meta/row-detail/row-detail.component';
import {TableModule} from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import {GraphSchemaModule} from '../graph-schema/graph-schema.module';
import {ToastModule} from 'primeng/toast';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {MultiSelectModule} from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import {DisplayModule} from '../field/field-display/display.module';
import {DataCompareComponent} from './data-compare/data-compare.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ExpandDataSectionComponent} from './expand-data-section/expand-data-section.component';
import {ExpandDataComponent} from './expand-data/expand-data.component';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {FieldsetModule} from 'primeng/fieldset';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {TableMetaSimpleComponent} from './table-meta-simple/table-meta-simple.component';
import {AccordionModule} from 'primeng/accordion';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';
import {TabViewModule} from 'primeng/tabview';
import {InputSwitchModule} from 'primeng/inputswitch';
import {DynRawDetailDialogComponent} from './table-meta/dyn-raw-detail-dialog/dyn-raw-detail-dialog.component';
import {DynRawDetailDisplayComponent} from './table-meta/dyn-raw-detail-display/dyn-raw-detail-display.component';
import {MessageModule} from 'primeng/message';
import {ProgressBarModule} from 'primeng/progressbar';
import {RippleModule} from "primeng/ripple";
import {DynRawNewDialogComponent} from './table-meta/dyn-raw-new-dialog/dyn-raw-new-dialog.component';
import {DynRawNewComponent} from './table-meta/dyn-raw-new/dyn-raw-new.component';
import {EditorModule} from "../field/field-editor/editor.module";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {InputTextModule} from "primeng/inputtext";
import {InputNumberModule} from "primeng/inputnumber";
import { TagModule } from 'primeng/tag';
import { SharedComponentsModule } from '../shared-components.module';
import { DynRawDetailFieldsComponent } from './table-meta/dyn-raw-detail-fields/dyn-raw-detail-fields.component';
import { DynRawDetailPurchasesComponent } from './table-meta/dyn-raw-detail-purchases/dyn-raw-detail-purchases.component';
import { DynRawDetailActivitiesComponent } from './table-meta/dyn-raw-detail-activities/dyn-raw-detail-activities.component';
import { DynRawDetailConsentsComponent } from './table-meta/dyn-raw-detail-consents/dyn-raw-detail-consents.component';
import { TranslateModule } from '@ngx-translate/core';
import { DynRawDetailHistoryComponent } from './table-meta/dyn-raw-detail-history/dyn-raw-detail-history.component';
import { DynRawDetailCampaignsComponent } from './table-meta/dyn-raw-detail-campaigns/dyn-raw-detail-campaigns.component';
import { DynRawDetailLtvComponent } from './table-meta/dyn-raw-detail-ltv/dyn-raw-detail-ltv.component';
import { ManualAcquisitionBulkDialogComponent } from './table-meta/manual-acquisition-bulk-dialog/manual-acquisition-bulk-dialog.component';
import { TagResultsDialogComponent } from './table-meta/tag-results-dialog/tag-results-dialog.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PipesModule } from '../../pipes/pipes.module';



const cmp = [
    TableMetaComponent,
    RowDetailComponent,
    DataCompareComponent,
    ExpandDataComponent,
    ExpandDataSectionComponent,
    TableMetaSimpleComponent,
    DynRawDetailDialogComponent,
    DynRawDetailDisplayComponent,
    DynRawDetailFieldsComponent,
    DynRawDetailPurchasesComponent,
    DynRawDetailActivitiesComponent,
    DynRawDetailConsentsComponent,
    DynRawDetailHistoryComponent,
    DynRawDetailCampaignsComponent,
    DynRawDetailLtvComponent,
    ManualAcquisitionBulkDialogComponent,
    TagResultsDialogComponent
];

@NgModule({
    declarations: [
        ...cmp,
        DynRawNewDialogComponent,
        DynRawNewComponent
    ],
    exports: [
        ...cmp,
    ],
    imports: [
        CommonModule,
        FormsModule,
        DisplayModule,

        TableModule,
        ToastModule,
        DropdownModule,
        DialogModule,
        CheckboxModule,
        ButtonModule,
        MultiSelectModule,
        TooltipModule,
        GraphSchemaModule,
        FieldsetModule,
        ToggleButtonModule,
        ScrollPanelModule,
        AccordionModule,
        MonacoEditorModule,
        TabViewModule,
        InputSwitchModule,
        MessageModule,
        ProgressBarModule,
        RippleModule,
        EditorModule,
        OverlayPanelModule,
        InputTextModule,
        InputNumberModule,
        ReactiveFormsModule,
        TagModule,
        SelectButtonModule,
        SharedComponentsModule,
        TranslateModule,
        PipesModule
    ]
})
export class TableDataModule {
}
